import type { ReactNode } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { isExternal, openLegal } from '@/lib/legalLinks';

/**
 * Ссылка на документ из `lib/legalLinks.ts` (25.09.2026).
 *
 * Свой адрес — обычный `<Link>`. Внешний (Google Docs) — через `openLegal`: в приложении это
 * системное окно, а не переход самого WebView, из которого нет дороги обратно. `<Link>` с полным
 * адресом роутер понял бы как относительный путь — поэтому ветка, а не один `<Link>`.
 */
export function LegalLink({
  url,
  fallback,
  className,
  children,
}: {
  url: string;
  /** Наша страница того же документа: открывается, если системное окно не открылось (`openLegal`). */
  fallback?: string;
  className?: string;
  children: ReactNode;
}) {
  const navigate = useNavigate();
  if (!isExternal(url)) {
    return (
      <Link to={url} className={className}>
        {children}
      </Link>
    );
  }
  return (
    <a
      href={url}
      className={className}
      onClick={(e) => {
        e.preventDefault();
        void openLegal(url, navigate, fallback);
      }}
    >
      {children}
    </a>
  );
}
